import { SiteLayout, StyleClosetTheme, get } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const StickyFooter = styled(SiteLayout.Footer)<Partial<StyleClosetTheme>>`
  position: sticky;
  bottom: 0;
  z-index: ${get('zIndexes.overlay')};
  ${({ theme }) =>
    `border-top: solid 2px ${get('colors.bmtGrey20')({ theme }) as string};
     background-color: ${get('colors.bmtWhite')({ theme }) as string}`};
`;

export default StickyFooter;
